import { SUBSCRIPTION_TIERS } from './subscription-tiers';

export interface SchemaSummary {
  code: string;
  name: string;
  subscriptionTier?: string | null;
}

export interface SchemaOption {
  value: string;
  label: string;
  description?: string;
}

interface SchemaOptionsConfig {
  isSuperUser: boolean;
}

const getLabel = (schema: SchemaSummary, config: SchemaOptionsConfig) => {
  if (!config.isSuperUser) {
    return schema.name;
  }

  return `${schema.name} (${schema.code})`;
};

const getDescription = (schema: SchemaSummary, config: SchemaOptionsConfig) => {
  const value = schema.subscriptionTier?.trim();

  if (!config.isSuperUser || !value) {
    return undefined;
  }

  const tier = SUBSCRIPTION_TIERS.find((option) => option.value === value);

  return tier?.label ?? value;
};

/**
 * Sorts schemas by name and maps them to select options. Superusers also see the schema code,
 * and the subscription tier as the description.
 */
export const toSchemaOptions = (
  schemas: ReadonlyArray<SchemaSummary>,
  config: SchemaOptionsConfig,
): SchemaOption[] =>
  [...schemas]
    .sort((a, b) => a.name.localeCompare(b.name))
    .map((schema) => ({
      value: schema.code,
      label: getLabel(schema, config),
      description: getDescription(schema, config),
    }));
